<template>
    <div id="app">
        <Navigation />
        <!-- img src="./assets/logo.png" -->
        <router-view/>

    </div>
</template>

<script>
    import Navigation from "@/components/globals/Navigation"
    export default {
        name: "App",
        components: {Navigation}
    }
</script>

<style>
    #app {
        font-family: 'Avenir', Helvetica, Arial, sans-serif;
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
        color: #2c3e50;
        margin: 0;
    }
</style>



// WEBPACK FOOTER //
// src/App.vue